import React from 'react';

import cn from 'classnames';

import s from './mc.module.scss';

/**
 * MCField — labeled form field. Renders a mono-eyebrow label above the
 * control (children) and an optional error line below. Pure presentational
 * wrapper — owns no state, only markup/layout. The control wrapper
 * guarantees a 44px min touch target.
 *
 * @param {React.ReactNode} label
 * @param {string} [htmlFor]    associates the label with a control id
 * @param {React.ReactNode} [error]
 * @param {React.ReactNode} children  the control(s)
 */
const MCField = ({ label, htmlFor, error, className, children, ...rest }) => (
  <div className={cn(s.field, className)} {...rest}>
    {label != null && (
      <label className={s.fieldLabel} htmlFor={htmlFor}>
        {label}
      </label>
    )}
    <div className={s.fieldControl}>{children}</div>
    {error ? <p className={s.fieldError}>{error}</p> : null}
  </div>
);

export default MCField;
